import React from 'react';
import {WithModal as WithModalComponent} from '@unthinkable/react-popper';
import {ModalViewStyles} from './theme';
import {useStyles} from '@unthinkable/react-theme';

export const WithModal = props => {
  const styles = useStyles(ModalViewStyles);
  return <WithModalComponent {...props} styles={styles} />;
};
